const LABELS = ["−40%", "0", "+60%"];

// 10 bins of 10 % from −40 % to +60 % (ends open); red = trailed, green = beat. `width` sizes the big variant 1:1.
export const OutcomeHist = ({ pct, big = false, width = 620, testid, title }) => {
  const W = big ? Math.max(280, width) : 240, H = big ? 215 : 78, base = big ? 170 : 55, top = big ? 125 : 42;
  const x0 = big ? 24 : 11, step = big ? (W - x0 - 20) / 10 : 22, bw = big ? step * 0.8 : 18;
  const max = Math.max(...pct, 0.0001);
  const zeroX = x0 + 4 * step - (step - bw) / 2;
  return (
    <svg className={big ? "" : "outcomehist"} viewBox={`0 0 ${W} ${H}`} role="img" aria-label={title} data-testid={testid}>
      <line x1={x0 - 1} y1={base} x2={W - (big ? 20 : 10)} y2={base} stroke="#465363" />
      {pct.map((v, j) => {
        const h = (v / max) * top;
        return (
          <rect key={j} x={x0 + j * step} y={base - h} width={bw} height={h} rx={big ? 3 : 1}
            fill={j < 4 ? "#f87171" : "#34d399"} opacity=".85">
            <title>{`${j * 10 - 40}% to ${(j + 1) * 10 - 40}%: ${v.toFixed(1)}% of outcomes`}</title>
          </rect>
        );
      })}
      <line x1={zeroX} y1={big ? 20 : 7} x2={zeroX} y2={base + (big ? 4 : 2)} stroke="#a0aab8" strokeDasharray="3 4" />
      <g fill="#a0aab8" fontSize={big ? 11 : 9}>
        <text x={x0 - 1} y={big ? 194 : 72}>{LABELS[0]}</text>
        <text x={zeroX} y={big ? 194 : 72} textAnchor="middle">{LABELS[1]}</text>
        <text x={W - (big ? 20 : 10)} y={big ? 194 : 72} textAnchor="end">{LABELS[2]}</text>
      </g>
    </svg>
  );
};
